import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import * as Util from '../../../common/utilities';

import { AnalyticsFilter, ClassDetails, PerformanceDetails } from '../';

import './Analytics.scss';

export class Analytics extends Component {
  state = {
    isPopoverDismissed: Boolean(
      localStorage.getItem('selectionBrowserPopoverDismissed')
    )
  };

  componentDidMount() {
    this.props.actions.getAssetTypes();
    this.props.actions.getJobs();
    this.props.actions.getAssetAttributes();
  }

  componentDidUpdate(prevProps) {
    if (Util.propChanged(prevProps, this.props, 'analytics.data.filter')) {
      this.props.actions.getPerformance(
        this.props.analytics.data.filter,
        undefined,
        { demo: this.props.flags?.demo || this.props.flags?.flags?.demo }
      );
      if (this.props.analytics.data.filter.filterBy === 'assetAttribute') {
        this.props.actions.getAssetDistributionByKey(
          this.props.analytics.data.filter.filter
        );
      }
    }
  }

  assetType(filter) {
    let assetType;
    if (filter.filterBy === 'assetClass') {
      assetType = filter.filter;
    } else if (filter.block) {
      assetType = filter.block.asset_type;
    }
    return assetType;
  }

  renderPerformance() {
    const { isLoading, hasLoadedOnce } = this.props.analytics;
    if (isLoading && !hasLoadedOnce) {
      return null;
    }

    const {
      filter,
      performance,
      blocks,
      jobs,
      attributeFilters
    } = this.props.analytics.data;
    const { distribution, types, keys, values } = this.props.assets.data;

    if (filter.filterBy && filter.filter) {
      const assetType = this.assetType(filter);
      const classDetails = (
        <div className="analytics-row">
          <ClassDetails
            assetType={assetType}
            assetTypes={this.props.assets.data.types}
            distribution={distribution[filter.filter]}
            filter={filter}
            blocks={blocks}
            jobs={jobs}
            details={performance.details}
            summary={performance.summary}
          />
        </div>
      );
      const hasArms = performance.summary && performance.summary.total_arms;
      return (
        <div className="analytics-row-container">
          {hasArms ? classDetails : null}
          <PerformanceDetails
            actions={this.props.actions}
            assetTypes={types}
            assetKeys={keys}
            attributeValues={values[attributeFilters.byAttribute]}
            performance={performance}
            filter={filter}
            attributeFilters={attributeFilters}
            attributeRadio={this.props.analytics.data.attributeRadio}
            handleAttributeChartChange={this.props.actions.modifyAttributeChart}
            distribution={distribution[filter.filter]}
            rules={this.props.rules}
          />
        </div>
      );
    }
    return null;
  }

  render() {
    const { actions, assets, analytics, rules } = this.props;

    return (
      <React.Fragment>
        <AnalyticsFilter
          actions={actions}
          filter={analytics.data.filter}
          assets={assets}
          jobs={analytics.data.jobs}
          jobsLoading={analytics.jobsLoading}
          jobDetails={analytics.data.jobDetails}
          jobDetailsLoading={analytics.jobDetailsLoading}
          rules={rules}
        />
        {this.renderPerformance()}
      </React.Fragment>
    );
  }
}

Analytics.propTypes = {
  actions: PropTypes.shape({
    openModal: PropTypes.func
  }),
  assets: PropTypes.object.isRequired,
  flags: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object,
  rules: PropTypes.object.isRequired
};

export default injectIntl(Analytics);
